import React, { useEffect } from 'react'

const SideBar = ({ activeScreen, setActiveScreen, isFirstLogin }) => {
  const firstLogin = isFirstLogin || false
  const handleMenuClick = (screen) => {
    // If first login, only allow profile screen
    if (firstLogin && screen !== 'profile') {
      return
    }
    setActiveScreen(screen)
  }

  const isActive = (screenOrScreens) => {
    if (Array.isArray(screenOrScreens)) {
      return screenOrScreens.includes(activeScreen) ? '' : 'collapsed'
    }
    return activeScreen === screenOrScreens ? '' : 'collapsed'
  }

  const isSubActive = (screen) => {
    return activeScreen === screen ? 'active' : ''
  }

  const isExpanded = (screens) => {
    return screens.includes(activeScreen) ? 'collapse show' : 'collapse'
  }

  // Ensure parent menus are expanded when a sub-item is active
  useEffect(() => {
    const menuMappings = {
      'recent-sales': '#receipts-nav',
      'products': '#products-nav',
      'print-barcodes': '#products-nav'
    }

    const targetId = menuMappings[activeScreen]
    if (targetId) {
      const collapseElement = document.querySelector(targetId)
      if (collapseElement && window.bootstrap && window.bootstrap.Collapse) {
        let bsCollapse = window.bootstrap.Collapse.getInstance(collapseElement)
        if (!bsCollapse) {
          bsCollapse = new window.bootstrap.Collapse(collapseElement, { toggle: false })
        }
        if (!collapseElement.classList.contains('show')) {
          bsCollapse.show()
        }
      }
    }
  }, [activeScreen])

  return (
    <aside id="sidebar" className="sidebar">
      <ul className="sidebar-nav" id="sidebar-nav">
        {/* New Sale */}
        <li className="nav-item">
          <a 
            className={`nav-link ${isActive('new-sale')} ${firstLogin ? 'disabled' : ''}`}
            href="#"
            onClick={(e) => { e.preventDefault(); handleMenuClick('new-sale'); }}
            style={firstLogin ? { pointerEvents: 'none', opacity: 0.5, cursor: 'not-allowed' } : {}}
          >
            <i className="bi bi-cart-plus" />
            <span>New Sale</span>
          </a>
        </li>{/* End New Sale Nav */}
        
        {/* Products */}
        <li className="nav-item">
          <a 
            className={`nav-link ${isActive(['products', 'print-barcodes'])} ${firstLogin ? 'disabled' : ''}`}
            data-bs-target="#products-nav"
            data-bs-toggle={firstLogin ? '' : 'collapse'}
            href="#"
            onClick={(e) => { e.preventDefault(); }}
            style={firstLogin ? { pointerEvents: 'none', opacity: 0.5, cursor: 'not-allowed' } : {}}
          >
            <i className="bi bi-box-seam" />
            <span>Products</span>
            <i className="bi bi-chevron-down ms-auto" />
          </a>
          <ul id="products-nav" className={`nav-content ${isExpanded(['products', 'print-barcodes'])}`} data-bs-parent="#sidebar-nav">
            <li>
              <a
                href="#"
                onClick={(e) => { e.preventDefault(); handleMenuClick('products'); }}
                className={isSubActive('products')}
                style={firstLogin ? { pointerEvents: 'none', opacity: 0.5, cursor: 'not-allowed' } : {}}
              >
                <i className="bi bi-circle" />
                <span>Products</span>
              </a>
            </li>
            <li>
              <a
                href="#"
                onClick={(e) => { e.preventDefault(); handleMenuClick('print-barcodes'); }}
                className={isSubActive('print-barcodes')}
                style={firstLogin ? { pointerEvents: 'none', opacity: 0.5, cursor: 'not-allowed' } : {}}
              >
                <i className="bi bi-circle" />
                <span>Print Barcodes</span>
              </a>
            </li>
          </ul>
        </li>{/* End Products Nav */}
        
        {/* Quotation */}
        <li className="nav-item">
          <a 
            className={`nav-link ${isActive('quotation')} ${firstLogin ? 'disabled' : ''}`}
            href="#"
            onClick={(e) => { e.preventDefault(); handleMenuClick('quotation'); }}
            style={firstLogin ? { pointerEvents: 'none', opacity: 0.5, cursor: 'not-allowed' } : {}}
          >
            <i className="bi bi-file-text" />
            <span>Quotation</span>
          </a>
        </li>{/* End Quotation Nav */}
        
        {/* Receipts */}
        <li className="nav-item">
          <a 
            className={`nav-link ${isActive(['recent-receipts'])} ${firstLogin ? 'disabled' : ''}`}
            data-bs-target="#receipts-nav" 
            data-bs-toggle={firstLogin ? '' : 'collapse'} 
            href="#"
            onClick={(e) => { e.preventDefault(); }}
            style={firstLogin ? { pointerEvents: 'none', opacity: 0.5, cursor: 'not-allowed' } : {}}
          >
            <i className="bi bi-receipt" />
            <span>Sales</span>
            <i className="bi bi-chevron-down ms-auto" />
          </a>
          <ul id="receipts-nav" className={`nav-content ${isExpanded(['recent-receipts'])}`} data-bs-parent="#sidebar-nav">
            <li>
              <a 
                href="#"
                onClick={(e) => { e.preventDefault(); handleMenuClick('recent-receipts'); }}
                className={isSubActive('recent-receipts')}
                style={firstLogin ? { pointerEvents: 'none', opacity: 0.5, cursor: 'not-allowed' } : {}}
              >
                <i className="bi bi-circle" />
                <span>Recent Sales</span>
              </a>
            </li>
          </ul>
        </li>{/* End Receipts Nav */}
        
        {/* Lay-by */}
        <li className="nav-item">
          <a 
            className={`nav-link ${isActive('layby')} ${firstLogin ? 'disabled' : ''}`}
            href="#"
            onClick={(e) => { e.preventDefault(); handleMenuClick('layby'); }}
            style={firstLogin ? { pointerEvents: 'none', opacity: 0.5, cursor: 'not-allowed' } : {}}
          >
            <i className="bi bi-calendar-check" />
            <span>Lay-by</span>
          </a>
        </li>{/* End Lay-by Nav */}
        
        {/* Profile */}
        <li className="nav-item">
          <a 
            className={`nav-link ${isActive('profile')}`}
            href="#"
            onClick={(e) => { e.preventDefault(); handleMenuClick('profile'); }}
          >
            <i className="bi bi-person" />
            <span>Profile</span>
          </a>
        </li>{/* End Profile Nav */}
      </ul>
    </aside>
  )
}

export default SideBar